module.exports = __webpack_public_path__ + "static/img/meeting_infomation.ad7064d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/meeting_infomation.png
// module id = gYzJ
// module chunks = 3